export default "__VITE_ASSET__adf5f0be__"